import { LookupSupportedLocales } from "../../intl-localematcher/lib/abstract/LookupSupportedLocales.mjs";
import { ToObject } from "./262.mjs";
import { GetOption } from "./GetOption.mjs";
function SupportedLocales(availableLocales, requestedLocales, options) {
  var matcher = "best fit";
  if (options !== void 0) {
    options = ToObject(options);
    matcher = GetOption(options, "localeMatcher", "string", ["lookup", "best fit"], "best fit");
  }
  if (matcher === "best fit") {
    return LookupSupportedLocales(Array.from(availableLocales), requestedLocales);
  }
  return LookupSupportedLocales(Array.from(availableLocales), requestedLocales);
}
export {
  SupportedLocales
};
